/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import { FC, useCallback, useEffect, useMemo, useState } from 'react'
import { FaChevronDown, FaDownload } from 'react-icons/fa'
import { ToastContainer } from 'react-toastify'
import { DateRangePickerComponent } from '@syncfusion/ej2-react-calendars'
import CN from 'classnames'
import { AnimatePresence, motion } from 'framer-motion'
import {
  useConfirmICSOrderList,
  useExportConfirmOrders,
  useGetCarrierProducts,
  useGetDistinctCourrierList,
  useGetWarehouseById,
} from 'framework/api/methods'
import useGetICSBulkOrderList from 'framework/api/methods/ICSBulkConsignment/useGetICSBulkOrderList'
import { addWebSocketEventListener } from 'framework/websocket/ws'
// eslint-disable-next-line import/no-extraneous-dependencies
import moment from 'moment'

import { Button, Input, JsonLoader, SimpleSelect } from 'components/atoms'
import { MultiSelect } from 'components/atoms/MultiSelect'
import EditShippingAddressModal from 'components/DrawerModals/BulkConsignmentNew/EditShippingAddressModal'
import UpdateCourrierModal from 'components/DrawerModals/BulkConsignmentNew/UpdateCourrierModal'
import UpdatePackageModal from 'components/DrawerModals/BulkConsignmentNew/UpdatePackageModal'
import { DataTable as BulkOrderListDataTable } from 'components/pages/BulkOrderConsignmentNew/Common/Tables/BulkOrderListDataTable'

import ScanSubmitFormBulkOrder from './ScanSubmitForm'

export interface ICSBulkOrderConsignmentProps {
  [x: string]: any
}

export const ICSBulkOrderConsignment: FC<ICSBulkOrderConsignmentProps> = ({
  className,
  isActive,
  onCloseClick,
  notify,
  setHistoryIsOpen,
  setSummaryData,
  setSummaryIsOpen,
  setICSBulkConsignmentIsOpen,
  seBulkConsignmentMenuIsOpen,
  FromHistory,
  setWarehouseDetails,
  setFromHistory,
  userDetails,
  integrationType,
  setIntegrationType,
  isOrderListScreen,
  setIsOrderListScreen,
  isScanScreen,
  setIsScanScreen,
  setTotalRowCount,
  totalRowCount,
  setProgress,
}: ICSBulkOrderConsignmentProps) => {
  const [mainLoadingState, setIsLoading] = useState(false)

  const [isLoadOrderList, setIsLoadOrderList] = useState(false)
  const [carrierList, setCarrierList] = useState<any>([])

  const [bulkOrderList, setBulkOrderList] = useState<any>([])
  const [selectAll, setSelectAll] = useState(false)
  const [selectedRowIds, setSelectedRowIds] = useState([])
  const [isFilterMenuOpen, setIsFilterModalOpen] = useState(true)
  const [shipmentPackageDetails, setShipmentPackageDetails] = useState()
  const [isUpdatePackageModalOpen, setIsUpdatePackageModalOpen] =
    useState(false)
  const [isUpdateCourrierModalOpen, setIsUpdateCourrierModalOpen] =
    useState(false)

  const [serchByWarehouseOrderNo, setSerchByWarehouseOrderNo] = useState('')
  const [isResetFilter, setIsResetFilter] = useState(false)
  const [bulkSlipNo, setBulkSlipNo] = useState<any>()
  const [bulkSlipOrders, setBulkSlipOrders] = useState<any>([])
  const [tableVariables, setTableVariables] = useState({
    take: 10,
    skip: 0,
    search: '',
  })

  interface OrderType {
    value: string
    label: string
    disabled: boolean
  }

  const [pageNumber, setPageNumber] = useState(1)
  const [isUpdate, setIsUpdate] = useState(false)
  const [filterActive, setFilterActive] = useState(false)
  const [warehouseId, setWarehouseId] = useState('')

  const [filterVariables, setFilterVariables] = useState<any>({
    destination: { label: 'All', value: '' },
    courrierType: { label: 'All', value: '' },
  })

  const destinationOptions = useMemo(
    () => [
      { value: 'AU', label: 'Australia' },
      { value: 'Non-AU', label: 'International' },
    ],
    [],
  )

  // Move the hook to the top level of the component
  /** API Call for Get Courrier List */
  const { mutate: getCourrierListMutate, isLoading: getCourrierListIsLoading } =
    useGetDistinctCourrierList()

  /** Process the Get Courrier List */
  const getCourrierList = useCallback(() => {
    setIsLoading(true)
    getCourrierListMutate(undefined, {
      onSuccess: ({ data }) => {
        const allowedCouriers = ['AUSPOST', 'AUSPOST_INTERNATIONAL']
        const updatedCarrierList = [
          { value: '', label: 'All', disabled: false },
          { value: 'No', label: 'No carrier', disabled: false },
          ...data.carriers
            .filter((c: { value: any }) => allowedCouriers.includes(c.value))
            .map((c: any) => ({ ...c, disabled: true })),
        ]
        setCarrierList(updatedCarrierList)
        //setIsLoading(false)
      },
      onError: (error: unknown) => {
        let message = 'Error...!'
        if (
          typeof error === 'object' &&
          error !== null &&
          'response' in error &&
          typeof (error as any).response === 'object' &&
          (error as any).response !== null &&
          'data' in (error as any).response
        ) {
          const errData = (error as any).response.data
          message = errData?.message || message
        }
        notify(message, 'error')
        setIsLoading(false)
      },
    })
  }, [getCourrierListMutate, notify])

  const validConfirm = () => {
    let notified = false

    const notifyOnce = (message: any) => {
      if (!notified) {
        notify(message, 'error')
        notified = true
      }
    }

    //Condition 1: Orders with Mixed Cons Numbers
    const consNumbers = new Set(
      selectedRowIds.map((order: any) => order.consNo).filter(Boolean),
    )
    if (consNumbers.size > 1) {
      notifyOnce('Please select orders with either one or no bulk Slip number.')
      return {
        valid: false,
      }
    }

    //Condition 2: Orders Missing Weight, Dimensions, or Carrier
    // Condition 2: Orders Missing Weight, Dimensions, or Carrier
    let errorMsg: string | null = null

    const missingDetails = selectedRowIds.some((order: any) => {
      const pkg = order?.shipments?.[0]?.packages?.[0]
      const carrierRaw = order?.partnerOrder?.defaultCarrierName ?? ''
      const product = order?.partnerOrder?.carrierProduct

      const carrier = String(carrierRaw).trim()
      const carrierUC = carrier.toUpperCase()

      const toNum = (v: any) => {
        if (v === 0) return 0
        const n = Number(v)
        return Number.isFinite(n) ? n : NaN
      }
      const gte = (v: any, min: number) =>
        Number.isFinite(toNum(v)) && toNum(v) >= min

      // 1) Weight must be > 0
      if (!(toNum(pkg?.weight) > 0)) {
        errorMsg = 'Weight must be greater than 0.'
        return true
      }

      // 2) Carrier required
      if (!carrier) {
        errorMsg = 'Carrier is required.'
        return true
      }

      // 3) Carrier product required (if you want a separate message)
      if (!product) {
        errorMsg = 'Carrier product is required.'
        return true
      }

      // 4) AUSPOST/AUSPOST_INTERNATIONAL: at least two dimensions >= 5
      if (carrierUC === 'AUSPOST' || carrierUC === 'AUSPOST_INTERNATIONAL') {
        const dimsOverOrEq5 = ['height', 'length', 'width']
          .map((k) => gte(pkg?.[k as keyof typeof pkg], 5))
          .filter(Boolean).length

        if (dimsOverOrEq5 < 2) {
          errorMsg =
            'For Courrier AUSPOST/AUSPOST_INTERNATIONAL, at least two dimensions (height/length/width) must be ≥ 5.'
          return true
        }
      }

      return false // this order is valid
    })

    if (missingDetails) {
      notifyOnce(errorMsg!)
      return { valid: false }
    }

    // Condition 3: No all Orders Selected
    if (selectedRowIds.length != bulkSlipOrders.length) {
      notifyOnce('Please select all records to proceed')
      return {
        valid: false,
      }
    }

    //Condition 4: Orders with Mixed Carriers
    const carriers = new Set(
      selectedRowIds
        .map((order: any) => order.partnerOrder?.defaultCarrierName)
        .filter(Boolean),
    )
    /* if (carriers.size > 1) {
      notify('Please select orders of one carrier.', 'error')
      return { valid: false }
    }*/

    // Condition 5: Successful Validation
    return { valid: true }
  }

  /** API Call for Get Similar Order List */
  const {
    mutate: getICSBulkOrderListMutate,
    isLoading: getICSBulkOrderListIsLoading,
  } = useGetICSBulkOrderList()

  /** Process the Get Similar Order List */
  async function getICSBulkOrderList() {
    setIsLoading(true)
    getICSBulkOrderListMutate(
      { orderNo: bulkSlipNo },
      {
        onSuccess: ({ data: successData }: any) => {
          if (!successData?.isExists) {
            setBulkOrderList(successData?.similarOrders)
            setTotalRowCount(successData?.similarOrders.length)
            setSelectedRowIds(successData?.similarOrders)
            setBulkSlipOrders(successData?.similarOrders)
            setWarehouseId(successData?.similarOrders[0]?.warehouseId)
            setIsOrderListScreen(true)
            setIsLoadOrderList(false)
            setIsLoading(false)
            setIsScanScreen(false)
          } else {
            if (
              successData.icsBulkConsignmentSummaryList.some(
                (a: any) => a.status === 'InProgress',
              )
            ) {
              addWebSocketEventListener('progress', (message: any) => {
                // Log the entire WebSocket message to verify its structure
                console.log('📩 WebSocket message received:', message)
                if (typeof message === 'string') {
                  message = JSON.parse(message)
                }

                // Destructure progress and splitReferance from the message
                const { progress: newProgress, splitReferance } = message

                // Check if progress and splitReferance are not undefined
                if (newProgress !== undefined && splitReferance !== undefined) {
                  // Update the progress state for the specific splitReferance
                  setProgress((prev: any) => ({
                    ...prev,
                    [splitReferance]: newProgress, // Use splitReferance as the key and progress as the value
                  }))
                }
              })
            }
            setSummaryData(successData?.icsBulkConsignmentSummaryList)
            setTotalRowCount(successData?.icsBulkConsignmentSummaryList.length)
            setIsOrderListScreen(false)
            setIsLoadOrderList(false)
            setWarehouseDetails(
              successData?.icsBulkConsignmentSummaryList[0]?.warehouseDetails,
            )
            setIsLoading(false)
            setICSBulkConsignmentIsOpen(false)
            setIsScanScreen(false)
            setSummaryIsOpen(true)
          }
        },
        onError: ({ response: { data: errData } }: any) => {
          notify(errData.message || 'Error...!', 'error')
          setIsLoading(false)
          setIsOrderListScreen(false)
          setIsScanScreen(true)
        },
      },
    )
  }

  const { mutate: createConfirmICSOrderListMutate } = useConfirmICSOrderList()

  /** Process the get Partner order Type List */
  async function createICSConfirmOrderList() {
    setIsLoading(true)
    createConfirmICSOrderListMutate(
      {
        warehouseOrderIds: selectedRowIds,
        bulkSlipNo,
      },
      {
        onSuccess: ({ data: successData }: any) => {
          seBulkConsignmentMenuIsOpen(false)
          setHistoryIsOpen(false)
          //setWarehoueDetails(successData.WarehouseDetailsList)
          setSummaryData(successData.icsBulkConsignmentSummaryList)
          setTotalRowCount(successData.totalCount)
          setIsOrderListScreen(false)
          setICSBulkConsignmentIsOpen(false)
          setSummaryIsOpen(true)

          if (onCloseClick) {
            onCloseClick()
          }
          setIsLoading(false)
        },
        onError: ({ response: { data: errData } }: any) => {
          notify(errData.message || 'Error...!', 'error')
          setIsLoading(false)
        },
      },
    )
  }
  /** Toaster Notifications */

  const disableOverlayClick = (event: any) => {
    event.stopPropagation()
  }
  function FormatDate(dateString: string) {
    // Assuming the input gives you a string like "Thu May 09 2024 00:00:00 GMT 1000 (Australian Eastern Standard Time)"
    // Create a new Date object from the string
    const dateObject = new Date(dateString)
    // Format the date as YYYY-MM-DD
    const year = dateObject.getFullYear()
    const month = dateObject.getMonth() + 1 // getMonth() returns month index (0-11), so add 1 for the actual month
    const day = dateObject.getDate()
    const formattedDate = `${year}/${month.toString().padStart(2, '0')}/${day
      .toString()
      .padStart(2, '0')}`
    return formattedDate
  }

  const handleConfirmClick = () => {
    const validationResult = validConfirm()
    if (!validationResult.valid) {
      // notify(validationResult.message, 'error') // Display error message
      return
    }
    if (validationResult.valid) {
      setIsLoading(true)
      setFromHistory(false)
      createICSConfirmOrderList()
      setWarehouseDetails(bulkSlipOrders[0]?.warehouse)
      //getWarehouseById(warehouseId)
    }
  }

  const handleSearchKeyPress = (e: any) => {
    if (e.key === 'Enter') {
      if (e.target.value !== '') {
        setBulkOrderList(
          bulkSlipOrders.filter((item: any) => {
            const matchOrder = item.orderNo === e.target.value

            return matchOrder
          }),
        )
      } else {
        setBulkOrderList(bulkSlipOrders)
      }
      setPageNumber(1)
    }
  }

  const getCarrierOptions = () => {
    if (filterVariables.destination.value === 'AU') {
      // Only show Australia Post, no "All"
      return carrierList.filter(
        (c: any) => c.value === 'AUSPOST' || c.value === 'No',
      )
    }
    if (filterVariables.destination.value === 'Non-AU') {
      // Only show Australia Post International, no "All"
      return carrierList.filter(
        (c: any) => c.value === 'AUSPOST_INTERNATIONAL' || c.value === 'No',
      )
    }
    // Show all options (including "All") if no destination selected
    return carrierList
  }

  /* const { mutate: exportCSVMutate } = useExportConfirmOrders()

  async function exportConfirmedOrders() {
    const validationResult = validConfirm()
    if (validationResult.valid) {
      exportCSVMutate(
        {
          warehouseOrderIds: selectedRowIds,
          principle: filterVariables.principle.label,
        },
        {
          onSuccess: (response) => {
            const blob = new Blob([response.data], { type: 'text/csv' })

            // Get filename from Content-Disposition header
            const contentDisposition = response.headers['content-disposition']
            const fileNameMatch =
              contentDisposition?.match(/filename="?([^"]+)"?/)
            const fileName =
              fileNameMatch?.[1] ||
              `confirmedOrders_${new Date()
                .toISOString()
                .replace(/[-:.]/g, '')
                .slice(0, 15)}.csv`

            const url = window.URL.createObjectURL(
              new Blob([blob], { type: 'text/csv' }),
            )
            const link = document.createElement('a')
            link.href = url
            link.download = `confirmedOrders_${new Date()
              .toISOString()
              .replace(/[-:.]/g, '')
              .slice(0, 15)}.csv`

            document.body.appendChild(link)
            link.click()
            link.remove()
            window.URL.revokeObjectURL(url)
          },
          onError: (err) => {
            notify('Download failed', 'error')
          },
        },
      )
    }*/

  useEffect(() => {
    if (filterVariables.destination.value === 'AU') {
      setFilterVariables((prev: any) => ({
        ...prev,
        courrierType: {
          label: 'AUSPOST',
          value: 'AUSPOST',
        },
      }))
    } else if (filterVariables.destination.value === 'Non-AU') {
      setFilterVariables((prev: any) => ({
        ...prev,
        courrierType: {
          label: 'AUSPOST_INTERNATIONAL',
          value: 'AUSPOST_INTERNATIONAL',
        },
      }))
    }
    // Optionally reset to "All" if neither is selected
    else {
      setFilterVariables((prev: any) => ({
        ...prev,
        courrierType: {
          label: 'All',
          value: '',
        },
      }))
    }
  }, [filterVariables.destination.value])

  useEffect(() => {
    setSelectedRowIds(bulkSlipOrders)
  }, [selectAll])

  useEffect(() => {
    if (isLoadOrderList) {
      getICSBulkOrderList()
      getCourrierList()
    }
  }, [bulkSlipNo, isLoadOrderList])

  useEffect(() => {
    if (isUpdate) {
      getICSBulkOrderList()
      setPageNumber(1)
      setIsUpdate(false)
      setSelectedRowIds([])
    }
  }, [isUpdate])
  return (
    <div
      className={CN(
        'flex items-center justify-center bg-white h-full w-full pt-4 px-8 pb-0',
        {},
        className,
      )}>
      {/* Loading Screen */}
      {mainLoadingState && (
        <div className='flex w-full h-full items-center justify-center bg-N-800 absolute z-[99] left-0 top-0 bg-opacity-20 cursor-not-allowed'>
          <JsonLoader size='xs' />
        </div>
      )}

      {isScanScreen && (
        <div className='flex flex-col w-full h-full bg-white overflow-y-auto styled-scroll'>
          <div className='flex flex-col w-full h-auto bg-white rounded-lg px-4 py-2'>
            <Button
              className='mb-1'
              size='xs'
              appearance='outline'
              onClick={() => {
                setICSBulkConsignmentIsOpen(false)
                seBulkConsignmentMenuIsOpen(true)
              }}>
              <i className='ri-arrow-left-line pr-3'></i> Back to menu
            </Button>
          </div>
          <div className='flex flex-col w-full h-full justify-center items-center'>
            <ScanSubmitFormBulkOrder
              isBulk={true}
              isLoading={getICSBulkOrderListIsLoading}
              setBulkSlipNo={setBulkSlipNo}
              setIsLoading={setIsLoading}
              setIsLoadOrderList={setIsLoadOrderList}
              setIsScanScreen={setIsScanScreen}
              setIsOrderListScreen={setIsOrderListScreen}
            />
          </div>
        </div>
      )}

      {isOrderListScreen && (
        <div className='flex flex-col w-full h-full bg-white overflow-y-auto styled-scroll'>
          <div className='flex flex-col w-full h-auto bg-white rounded-lg px-4 py-2'>
            <Button
              className='mb-1'
              size='xs'
              appearance='outline'
              onClick={() => {
                setICSBulkConsignmentIsOpen(true)
                setIsOrderListScreen(false)
                setIsScanScreen(true)
              }}>
              <i className='ri-arrow-left-line pr-3'></i> Back to bulk order
              consignment
            </Button>
          </div>
          <div className='flex flex-col w-full h-auto bg-white rounded-lg px-4 py-2'>
            <div className='flex flex-col w-[432px] pl-2 relative ml-auto'>
              <input
                /*(onChange={(e: any) => {
                  handleSearchKeyPress(e)
                }}*/
                onKeyPress={(e: any) => {
                  handleSearchKeyPress(e)
                }}
                type='text'
                placeholder='Search by WMS OrderNo'
                className='pr-4 pl-11 py-1 w-full outline-none border text-N-500 border-N-200 rounded-md text-sm'
              />
              <i
                className='ri-search-2-line absolute top-0 bottom-0 flex items-center left-[22px] text-1xl text-N-500 cursor-pointer'
                onClick={() => {
                  setTableVariables({
                    ...tableVariables,
                    search: serchByWarehouseOrderNo,
                  })
                }}></i>
            </div>
            <div className='flex w-full items-center justify-between pt-6'>
              <Button
                onClick={() => {
                  setIsFilterModalOpen(!isFilterMenuOpen)
                }}
                appearance={isFilterMenuOpen ? 'default' : 'outline'}>
                <i className='ri-filter-3-line pr-3'></i> Filter
              </Button>
              {filterActive && (
                <div className='w-[6px] h-[2px] bg-R-500 rounded-full absolute top-[0px] right-[-2px]'></div>
              )}
            </div>
            <AnimatePresence initial={false}>
              {isFilterMenuOpen && (
                <motion.div
                  className='flex flex-col bg-white w-full'
                  initial='collapsed'
                  animate='open'
                  exit='collapsed'
                  transition={{ type: 'tween', duration: 0.3 }}
                  variants={{
                    open: { opacity: 1, y: 0, height: 'auto' },
                    collapsed: { opacity: -1, y: -35, height: 0 },
                  }}>
                  {/** Input field of filtering section */}
                  <div className='flex flex-col w-full mb-4 py-2 z-50'>
                    <div className='flex flex-col w-full mb-4 py-2 z-40'>
                      <div className='flex flex-row w-full gap-x-5'>
                        <div className='flex flex-col w-1/6 z-[40]'>
                          <span className='pb-1 text-N-700'>Destination</span>
                          <SimpleSelect
                            value={filterVariables?.destination}
                            options={[
                              { label: 'All', value: '' },
                              ...destinationOptions,
                            ]}
                            onChange={(e: any) => {
                              setFilterVariables({
                                ...filterVariables,
                                destination: {
                                  label: e.label,
                                  value: e.value,
                                },
                              })
                            }}
                          />
                        </div>
                        <div className='flex flex-col w-1/6 z-[50]'>
                          <span className='pb-1 text-N-700'>Courier Type</span>
                          <SimpleSelect
                            value={filterVariables.courrierType}
                            options={getCarrierOptions()}
                            onChange={(e: any) => {
                              setFilterVariables({
                                ...filterVariables,
                                courrierType: {
                                  label: e.label,
                                  value: e.value,
                                },
                              })
                            }}
                          />
                        </div>
                        <div className='flex items-end gap-3 w-1/6 z-[50] '>
                          <Button
                            onClick={() => {
                              const filteredOrders = bulkSlipOrders.filter(
                                (item: any) => {
                                  const matchesDestination = !filterVariables
                                    .destination.value
                                    ? true
                                    : filterVariables.destination.value === 'AU'
                                    ? item.partnerOrder.shippingAddress
                                        .countryCode === 'AU'
                                    : filterVariables.destination.value ===
                                      'Non-AU'
                                    ? item.partnerOrder.shippingAddress
                                        .countryCode !== 'AU'
                                    : true
                                  const matchesCourier =
                                    filterVariables.courrierType.value === 'No'
                                      ? !item.partnerOrder.defaultCarrierName
                                      : !filterVariables.courrierType.value ||
                                        item.partnerOrder.defaultCarrierName ===
                                          filterVariables.courrierType.value
                                  return matchesDestination && matchesCourier
                                },
                              )
                              setBulkOrderList(filteredOrders)
                              setSelectedRowIds(filteredOrders)
                              setTotalRowCount(filteredOrders.length)
                              setPageNumber(1)
                            }}>
                            Apply
                          </Button>
                          <Button
                            appearance='dull'
                            onClick={() => {
                              setBulkOrderList(bulkSlipOrders)
                              setSelectedRowIds(bulkSlipOrders)
                              setTotalRowCount(bulkSlipOrders.length)
                              setFilterVariables({
                                destination: {
                                  label: 'All',
                                  value: '',
                                },
                                courrierType: {
                                  label: 'All',
                                  value: '',
                                },
                              })
                              setFilterActive(false)
                              setIsResetFilter(true)
                              setPageNumber(1)
                            }}>
                            Clear
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='flex flex-row w-full mb-2 py-0 z-30'></div>
                </motion.div>
              )}
            </AnimatePresence>
            <div className='w-full flex justify-end gap-1 p-4 py-0 bg-white'>
              <Button
                className='px-6 py-2 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition'
                onClick={() => setIsUpdatePackageModalOpen(true)}
                disabled={selectedRowIds.length == 0}>
                Update W & D
              </Button>
              <Button
                className='px-6 py-2 bg-P-600 text-white rounded-md hover:bg-P-700 transition'
                onClick={() => {
                  const destinations = selectedRowIds.map(
                    (row: any) =>
                      row?.partnerOrder?.shippingAddress?.countryCode,
                  )
                  const internationalDestinations = destinations.filter(
                    (dest: string) => dest !== 'AU',
                  )
                  //const uniqueDestinations = new Set(destinations)
                  const localDestinations = destinations.filter(
                    (dest: string) => dest === 'AU',
                  )

                  if (
                    localDestinations.length > 0 &&
                    internationalDestinations.length > 0
                  ) {
                    notify(
                      'Please select rows with the same destination.',
                      'error',
                    )
                    return
                  }
                  setIsUpdateCourrierModalOpen(true)
                }}
                disabled={selectedRowIds.length == 0}>
                Update Courier
              </Button>
            </div>
            <div className='flex flex-col w-full h-auto bg-white rounded-lg px-4 py-2 overflow: visible'>
              <BulkOrderListDataTable
                key={bulkOrderList?.length}
                itemData={bulkOrderList || []}
                className=''
                setTableVariables={setTableVariables}
                tableVariables={tableVariables}
                totalRowCount={totalRowCount}
                setSelectedRowIds={setSelectedRowIds}
                selectedRowIds={selectedRowIds}
                selectAll={selectAll}
                setSelectAll={setSelectAll}
                setIsLoading={setIsLoading}
                setPageNumber={setPageNumber}
                pageNumber={pageNumber}
                setUpdateCarrier={setIsUpdateCourrierModalOpen}
                bulkSlipNo={bulkSlipNo}
                setIsUpdatePackageModalOpen={setIsUpdatePackageModalOpen}
                setIsUpdateCourrierModalOpen={setIsUpdateCourrierModalOpen}
                integrationType='ICSWms'
                setIntegrationType={setIntegrationType}
              />
            </div>

            <div className='flex flex-col w-full h-auto bg-white rounded-lg px-4 py-5 overflow: visible z-[60]'>
              {isUpdatePackageModalOpen && (
                <UpdatePackageModal
                  isActive={isUpdatePackageModalOpen}
                  notify={notify}
                  onCloseClick={() => {
                    setIsUpdatePackageModalOpen(false)
                    //resetUpdatePackageModalDetails()
                  }}
                  setShipmentPackageDetails={setShipmentPackageDetails}
                  shipmentPackageDetails={shipmentPackageDetails}
                  setIsUpdate={setIsUpdate}
                  setIsLoading={setIsLoading}
                  /*callOrderShipmentsById={() => {
              //getBulkOrder(bulkConsignmentId)
            }}*/
                  selectedRowIds={selectedRowIds}
                />
              )}

              {isUpdateCourrierModalOpen && (
                <UpdateCourrierModal
                  isActive={isUpdateCourrierModalOpen}
                  notify={notify}
                  onCloseClick={() => {
                    setIsUpdateCourrierModalOpen(false)
                    //resetUpdatePackageModalDetails()
                  }}
                  setIsLoading={setIsLoading}
                  setIsUpdate={setIsUpdate}
                  selectedRowIds={selectedRowIds}
                  useGetCarrierProducts={useGetCarrierProducts}
                />
              )}
            </div>

            <div className='w-full flex justify-end items-center p-4 bg-white border-gray-300'>
              <Button
                className='px-6 py-2 bg-orange-500 text-white rounded-md'
                onClick={handleConfirmClick}>
                Confirm
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* Footer Container */}
    </div>
  )
}

ICSBulkOrderConsignment.defaultProps = {}

export default ICSBulkOrderConsignment
